import { render } from "./DynamicHtmlStrong.vue?vue&type=template&id=5a1fcc99&ts=true"
import script from "./DynamicHtmlStrong.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlStrong.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlStrong.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a1fcc99"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a1fcc99', __exports__)) {
    api.reload('5a1fcc99', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlStrong.vue?vue&type=template&id=5a1fcc99&ts=true", () => {
    api.rerender('5a1fcc99', render)
  })

}


export default __exports__